import React, { Fragment, useEffect, useState } from "react";
import { IconClipboard } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { LangConstant, SystemConstant } from "const";
import { useCreateUnit, useEditUnit } from "hooks";
import { BranchUtils, CommonUtils, SystemUtils, UnitUtils } from "utils";

const UnitDialog = ({ open, selectedUnit, onClose }) => {
  const isEdit = Boolean(selectedUnit);
  const currentBranch = BranchUtils.getCurrentBranch();

  const { t: getLabel } = useTranslation();
  const unitDetail = getLabel(LangConstant.OBJ_UNIT_DETAIL, { returnObjects: true });
  const unitError = getLabel(LangConstant.OBJ_UNIT_ERROR, { returnObjects: true });
  const { createUnit } = useCreateUnit();
  const { editUnit } = useEditUnit();

  const [unitNameInput, setUnitNameInput] = useState(null);

  const handleChangeUnitName = event => {
    setUnitNameInput(CommonUtils.capitalizeFirstLetter(event.target.value));
  };

  const handleClose = () => {
    onClose();
    setUnitNameInput("");
  };

  const handleSubmit = () => {
    if (!UnitUtils.isValidName(unitNameInput)) {
      SystemUtils.appendNotification(getLabel(unitError[SystemConstant.UNIT_ERROR.IN_WRONG_FORMAT]), "error");
    } else if (isEdit) {
      editUnit({
        unitName: unitNameInput,
        unitId: selectedUnit?.unitId || "",
        onClose: handleClose,
      });
    } else {
      createUnit({
        unitName: unitNameInput,
        onClose: handleClose,
      });
    }
  };

  useEffect(() => {
    if (selectedUnit) setUnitNameInput(selectedUnit.unitName);
  }, [selectedUnit]);

  // ESC key handler
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = e => {
      if (e.key === "Escape") handleClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open]);

  if (!open) return null;

  return (
    <Fragment>
      <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
      <div className="modal modal-blur show d-block" tabIndex="-1" style={{ zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ minWidth: 550 }}>
            <div className="modal-header">
              <h5 className="modal-title" style={{ fontSize: 18, fontWeight: 600 }}>
                {getLabel(isEdit ? LangConstant.TXT_EDIT_UNIT : LangConstant.TXT_CREATE_UNIT)}
              </h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label" style={{ fontWeight: 600 }}>
                  {unitDetail.name}
                </label>
                <div className="input-group">
                  <span className="input-group-text">
                    <IconClipboard size={18} />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    value={unitNameInput || ""}
                    onChange={handleChangeUnitName}
                    placeholder={getLabel(LangConstant.TXT_ENTER_UNIT_NAME)}
                  />
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label" style={{ fontWeight: 600 }}>
                  {unitDetail.branch}
                </label>
                <div className="input-group">
                  <span className="input-group-text">
                    <IconClipboard size={18} />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    disabled
                    value={currentBranch.name}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-outline-danger"
                style={{ flex: 1 }}
                onClick={handleClose}
              >
                {getLabel(LangConstant.L_CANCEL_ADD_BRANCH)}
              </button>
              <button
                className="btn btn-primary"
                style={{ flex: 1 }}
                onClick={handleSubmit}
              >
                {getLabel(isEdit ? LangConstant.L_CONFIRM_BUTTON : LangConstant.L_CREATE)}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UnitDialog;
